import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const Footer: React.FC = () => {
  const { colors } = useTheme();
  const currentYear = new Date().getFullYear();

  return (
    <footer className={`${colors.surface} border-t ${colors.border} mt-auto`}>
      <div className="px-5 py-3.5">
        <div className="flex flex-col md:flex-row justify-between items-center gap-2">
          <div className={`text-xs ${colors.textMuted}`}>
            © {currentYear} Unibyte Management System
          </div>
          <div className={`flex items-center gap-5 text-xs ${colors.textMuted}`}>
            <button
              type="button"
              onClick={() => {
                console.log('Privacy Policy clicked');
              }}
              className={`${colors.primaryFg} hover:opacity-80 transition-opacity cursor-pointer`}
            >
              Privacy
            </button>
            <button
              type="button"
              onClick={() => {
                console.log('Terms of Service clicked');
              }}
              className={`${colors.primaryFg} hover:opacity-80 transition-opacity cursor-pointer`}
            >
              Terms
            </button>
            <button
              type="button"
              onClick={() => {
                console.log('Support clicked');
              }}
              className={`${colors.primaryFg} hover:opacity-80 transition-opacity cursor-pointer`}
            >
              Support
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
